import { fun, baseData, getLan } from '../js/common.js'

function addDeviceSet(obj) {
    if ('pwd' in obj) {
        var str = '<dynamic-password>' + obj.pwd + '</dynamic-password>';
        var c = 'device-bind-hs';
    } else {
        var str = '<auth-code>' + obj.code + '</auth-code>';
        var c = 'device-bind';
    };
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<session>' + obj.sessionId + '</session>' +
    //     '<command>' + c + '</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<device-id>' + obj.id + '</device-id>' +
    //     '<device-name>' + obj.name + '</device-name>' + str +
    //     '</content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            session: obj.sessionId,
            command: 'pwd' in obj ? 'device-bind-hs' : 'device-bind',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'device-id': obj.id,
            'device-name': obj.name,
            ['pwd' in obj ? 'dynamic-password' : 'auth-code']: 'pwd' in obj ? obj.pwd : obj.code
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
}

function editDeviceSet(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<session>' + obj.sessionId + '</session>';
    // if (obj.isChange) {
    //     xml += '<command>edit-device-memo</command>';
    // } else {
    //     xml += '<command>edit-device-name</command>';
    // };
    // xml += '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<device-id>' + obj.id + '</device-id>';
    // if (obj.isChange) {
    //     xml += '<memo-name>' + obj.name + '</memo-name>';
    // } else {
    //     xml += '<device-name>' + obj.name + '</device-name>';
    // };
    // xml += '<is-hs-device>' + obj.isHs + '</is-hs-device></content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            session: obj.sessionId,
            command: obj.isChange ? 'edit-device-memo' : 'edit-device-name',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'device-id': obj.id,
            'device-name': obj.name,
            [obj.isChange ? 'memo-name' : 'device-name']: obj.name,
            'is-hs-device': obj.isHs
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
}

function editDeviceSetHs(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<session>' + obj.sessionId + '</session>' +
    //     '<command>device-info-update-hs</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<device-id>' + obj.id + '</device-id>' +
    //     '<dynamic-password>' + obj.upo + '</dynamic-password></content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            session: obj.sessionId,
            command: 'device-info-update-hs',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'device-id': obj.id,
            'dynamic-password': obj.upo
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
}

function userMesSet(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<session>' + obj.sessionId + '</session>' +
    //     '<command>edit-password</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<password-old>' + obj.old + '</password-old>' +
    //     '<password-new>' + obj.new + '</password-new>' +
    //     '</content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            session: obj.sessionId,
            command: 'edit-password',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'password-old': obj.old,
            'password-new': obj.new
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
}
var bomb = {
    addDeviceSet: addDeviceSet,
    editDeviceSet: editDeviceSet,
    editDeviceSetHs: editDeviceSetHs,
    userMesSet: userMesSet
};
export default bomb;


// WEBPACK FOOTER //
// ./src/assets/js/bomb.js